module.exports = __webpack_public_path__ + "static/young-leader-photo-river_bunkley-e94a0766af84a6213438305dd8ce4dfc.jpg";